import { useContext } from "react";
import { ConfigContext } from "joynt/meeting/agora-ng/context/ConfigContext";

export function useConfig() {
    return useContext(ConfigContext);
}
